// src/lib/directus.js
import { createDirectus, rest, createItem   } from '@directus/sdk';

const DIRECTUS_URL = process.env.REACT_APP_DIRECTUS_URL;

if (!DIRECTUS_URL) {
  throw new Error('REACT_APP_DIRECTUS_URL is not defined in .env');
}

const directus = createDirectus(DIRECTUS_URL)
  .with(rest());

export default directus;